<template>
    <div class="newsList-wrapper">
        <div class="pc-newsList" v-if="!isPhone" :class="columnId && `pc-newsList-${$Common.Base64.decode(columnId)}`">
            <div class="news-item pointer" :class="{'subject-item': isSubjectList || isActivity, 'isSpecial': isSpecial}" v-for="(item ,i) in list" :key="i" @click="toDetail(item)">
                <div class="img bgc-default">
                    <img :src="(item.images && item.images.img169)" :onload="imgLoaded" :onerror="errorImg" alt="">
                    <span v-show="item.flag == 3" class="video-icon"></span>
                    <span v-show="item.flag == 3" class="video-duration">{{item.itemDuration | videoDuration}}</span>
                    <span v-show="item.flag == 1" class="label" :class="{'isSpecial': isSpecial}">专题</span>
                </div>
                <div class="text" v-if="isSubjectList || isActivity">
                    <div class="title line-2">
                        {{item.itemTitle}}
                    </div>
                </div>
                <div class="text" v-else>
                    <div class="title line-2">
                        {{item.itemTitle}}
                    </div>
                    <div class="text-line"></div>
                    <div class="meta clearfix">
                        <span v-show="item.sourceName">
                            {{item.sourceName}}
                        </span>
                        <span class="publishShowTime" v-show="item.itemPublishTime">
                            {{formatDate(item.itemPublishTime)}}
                        </span>
                        <span class="readNum" v-show="item.readNum && item.flag != 1">
                            <img src="./../assets/img/eyes.png" alt="">
                            {{item.readNum | resetNum}}
                        </span>
                    </div>
                </div>
            </div>
            <div class="news-item holder" v-show="holder" v-for="i in holder" :key="'holder' + i*100"></div>
        </div>
        <div class="wap-newsList" v-if="isPhone" :class="columnId && `wap-newsList-${$Common.Base64.decode(columnId)}`">
            <a :href="toWapDetail(item)" target="_blank" class="news-item" :class="{'isSpecial': isSpecial}" v-for="(item, i) in list" :key="i">
                <div class="img bgc-default">
                    <img :src="(isRecommend ? (item.images && item.images.img43) : (item.images && (item.flag == 1 ? item.images.img169 : item.images.img43))) || require('./../assets/img/default.png')" :onload="imgLoaded" :onerror="errorImg" alt="">
                    <span v-show="item.flag == 3" class="video-icon"></span>
                    <span v-show="item.flag == 3" class="video-duration">{{item.itemDuration | videoDuration}}</span>
                    <span v-show="item.flag == 1" class="label" :class="{'isSpecial': isSpecial}">专题</span>
                </div>
                <div v-if="!isActivity" class="text">
                    <div class="title line-3">{{item.itemTitle}}</div>
                    <div class="meta" >
                        <span v-show="item.sourceName" class="line-1 line-width">{{item.sourceName}}</span>
                        <!-- <span class="publishShowTime" v-show="item.itemPublishTime">
                            {{formatDate(item.itemPublishTime)}}
                        </span>
                        <span class="readNum" v-show="item.readNum">
                            <img src="./../assets/img/eyes.png" alt="">
                            {{item.readNum | resetNum}}
                        </span> -->
                    </div>
                </div>
                <div v-else class="text">
                    <div class="title line-3">{{item.itemTitle}}</div>
                </div>
            </a>
        </div>
    </div>
</template>
<script>
import dayjs from 'dayjs'
// 新闻列表公用组件
export default {
    name: 'NewsList',
    data() {
        return {
            imgLoaded: `this.style.background = 'none'`,
            errorImg: 'this.src="'+ require('./../assets/img/default.png') + '"'
        }
    },
    props: {
        column: { // 列数
            type: Number,
            default: 4
        },
        list: { //数据
            type: Array,
            default: []
        },
        type: { // 用于新闻详情页下一篇类型 1-信息流列表 2-专题列表 3-栏目列表
            type: Number,
            default: null
        },
        columnId: {
            type: String,
            default: null
        },
        subjectId: {
            type: String,
            default: null
        },
        skId: {
            type: String,
            default: null
        },
        channelId: {
            type: String,
            default: null
        },
        channelType: {
            type: String,
            default: null
        },
        isSubjectList: {
            type: Boolean,
            default: false
        },
        isActivity: {
            type: Boolean,
            default: false
        },
        isSpecial: {
            type: Boolean,
            default: false
        },
        isRecommend: {
            type: Boolean,
            default: false
        },
        isNeedSubjectId:{
            type: Boolean,
            default: false
        }
    },
    methods: {
        toDetail(item) {
            //统计外链文章
            if(item.flag == 4){
                this.$axios.post(
                    this.$ApiInfo.getLink,
                    {
                        newsId: item.itemId,
                    }
                ).then(res => {
                    console.log(res)
                })
            }
            // 辟谣没有直播和图集
            if (item.flag == 2 || item.flag == 5) return
            let url = ''
            // flag  跳转方式  0-新闻 1-专题 2-直播 3-视频 4-外链  5-图集
            switch (item.flag) {
                case 0:
                    url = this.$router.resolve({
                        // path: this.channelId ? `/news/${this.$Common.Base64.encode(item.itemId)}}/${this.$Common.Base64.encode(this.channelId)}` : `/news/${this.$Common.Base64.encode(item.itemId)}}`
                        path: `/news/${this.$Common.Base64.encode(item.itemId)}${this.channelId ? '/' + this.$Common.Base64.encode(this.channelId) : ''}${this.isNeedSubjectId ? '?subjectId=' + this.subjectId : ''}`
                    })['href']
                    break;
                case 1:
                    url = this.$router.resolve({
                        path: `/subject/${this.$Common.Base64.encode(item.itemId)}`
                    })['href']
                    break;
                case 3:
                    url = this.$router.resolve({
                        // path: this.channelId ? `/news/${this.$Common.Base64.encode(item.itemId)}}/${this.$Common.Base64.encode(this.channelId)}` : `/news/${this.$Common.Base64.encode(item.itemId)}}`
                        path: `/news/${this.$Common.Base64.encode(item.itemId)}${this.channelId ? '/' + this.$Common.Base64.encode(this.channelId) : ''}${this.isNeedSubjectId ? '?subjectId=' + this.subjectId : ''}` 
                    })['href']
                    break;
                case 4:
                    url = item.itemExternalUrl
                    break;
                default:
                    break;
            }
            window.open(url)
        },
        toWapDetail(item) {
            // 辟谣没有直播和图集
            if (item.flag == 2 || item.flag == 5) return
            let url = ''
            // flag  跳转方式  0-新闻 1-专题 2-直播 3-视频 4-外链  5-图集
            switch (item.flag) {
                case 0:
                    url = this.$router.resolve({
                        path: this.channelId ? `/news/${this.$Common.Base64.encode(item.itemId)}}/${this.$Common.Base64.encode(this.channelId)}` : `/news/${this.$Common.Base64.encode(item.itemId)}}`
                    })['href']
                    break;
                case 1:
                    url = this.$router.resolve({
                        path: `/subject/${this.$Common.Base64.encode(item.itemId)}`
                    })['href']
                    break;
                case 3:
                    url = this.$router.resolve({
                        path: this.channelId ? `/news/${this.$Common.Base64.encode(item.itemId)}/${this.$Common.Base64.encode(this.channelId)}` :`/news/${this.$Common.Base64.encode(item.itemId)}`
                    })['href']
                    break;
                case 4:
                    //统计外链文章
                    this.$axios.post( this.$ApiInfo.getLink,{newsId: item.itemId})
                    url = item.itemExternalUrl
                    break;
                default:
                    break;
            }
            return url 
        },
        dealQuery() {
            let obj = {};
            this.type && Object.assign(obj, {type: this.type});
            this.columnId && Object.assign(obj, {columnId: this.columnId});
            this.subjectId && Object.assign(obj, {subjectId: this.subjectId});
            this.skId && Object.assign(obj, {skId: this.skId});
            this.channelId && Object.assign(obj, {channelId: this.channelId});
            this.channelType && Object.assign(obj, {channelType: this.channelType});
            return obj;
        },

        formatDate(date) {
            const dayjsObj = dayjs(date);
            const dayjsNow = dayjs();
            
            if (dayjsNow.diff(dayjsObj, 'minute') < 1) return '刚刚';
            if (dayjsNow.diff(dayjsObj, 'hour') < 1) return `${dayjsNow.diff(dayjsObj, 'minute')}分钟前`;
            if (dayjsNow.diff(dayjsObj, 'day') < 1) return `${dayjsNow.diff(dayjsObj, 'hour')}小时前`;
            if (dayjsNow.diff(dayjsObj, 'month') < 1) return `${dayjsNow.diff(dayjsObj, 'day')}天前`;
            
            return dayjsObj.format('YYYY-MM-DD');
            // return dayjs(date).format(format);
        }
    },
    computed: {
        holder() {
            if(this.list && this.list.length) {
                let beNumber = this.column
                return this.list.length % beNumber == 0 ? 0 : beNumber - (this.list.length % beNumber)
            }
            return 0
        },
        isPhone() {
            return this.$Common.Attribute.isMb()
        }
    }
}
</script>
<style lang="less" scoped>
.newsList-wrapper {
    .pc-newsList {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        &.pc-newsList-208 {
            .news-item .text {
                .title{
                    font-size: 1rem;
                    line-height: 1.57rem;
                }
            }
        }
        .news-item {
            display: inline-block;
            width: 14.875rem;
            height: 15.125rem;
            background: #fff;
            margin-bottom: 1.5rem;
            box-shadow: 0px 0px 1px 1px rgba(0, 0, 0, 0.14);
            transition: all .5s;
            // &:hover {
            //     transform: scale(1.02);
            //     box-shadow: 0px 0px 10px 10px rgba(0, 0, 0, 0.14);
            // }
            &.isSpecial{
               box-shadow: 0px 0px 1px 1px #385C40;
            }
            &:hover .img img{
                transform: scale(1.05);
            }
            .img {
                height: 8.375rem;
                position: relative;
                overflow: hidden;
                .video-duration {
                    padding: 0.125rem 0.25rem;
                    color: #fff;
                    font-size: 0.6875rem;
                    position: absolute;
                    bottom: 0.5rem;
                    left: 0.6875rem;
                    background: rgba(0, 0, 0, 0.5);
                    border-radius: 0.125rem;
                }
                .video-icon {
                    position: absolute;
                    width: 3.1875rem;
                    height: 3.1875rem;
                    background: url('./../assets/img/video_play.png') center no-repeat;
                    background-size: cover;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
                img {
                    transition: all .5s;
                }
                .label{
                    &.isSpecial{
                        background: #385C40;
                    }
                }
            }
            .text {
                padding: 0.625rem 0.75rem;
                .title {
                    margin-bottom: 0.625rem;
                    font-size: 0.9375rem;
                    color: #333333;
                    font-weight: 600;
                    line-height: 1.5625rem;
                    height: 3.125rem;
                    overflow: hidden;
                }
                .meta {
                    padding-top: 0.625rem;
                    color: #999999;
                    font-size: 0.75rem;
                    line-height: 0.875rem;
                    span {
                        float: left;
                        max-width: 32%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        margin-left: 0.5em;
                        &:first-of-type {
                            margin-left: 0;
                        }
                    }
                    .readNum {
                        float: right;
                        margin-left: 0;
                        img {
                            width: 0.8125rem;
                            height: 0.5rem;
                        }
                    }
                    .publishShowTime {
                        max-width: 40%;
                    }
                }
            }
        }
        .subject-item {
            height: 12.875rem;
        }
        .holder {
            opacity: 0;
            height: 0;
        }
    }

    .wap-newsList {
        padding: 4.4vw 4vw 0;
        &.wap-newsList-208 {
            .news-item .text {
                .title {
                    font-size: 4.815vw;
                    line-height: 6.667vw;
                }
                .meta {
                    font-size: 3.241vw;
                }
            }
        }
        .news-item {
            width: 100%;
            padding-bottom: 4.267vw;
            border-bottom: 1px solid #EEEEEE;
            margin-bottom: 4.267vw;
            display: flex;
            &.isSpecial{
                border-bottom: 1px solid #385C40;
            }
            .img {
               width: 32.533vw;
               height: 24.4vw;
            //    float: left;
               position: relative;
               flex-shrink: 0;
                .video-icon {
                    position: absolute;
                    width: 6.667vw;
                    height: 6.667vw;
                    background: url('./../assets/img/video_play.png') center no-repeat;
                    background-size: cover;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
                .video-duration {
                    padding: 0.267vw 0.533vw;
                    color: #fff;
                    font-size: 1.6vw;
                    position: absolute;
                    bottom: 3.998px;
                    left: 0.533vw;
                    background: rgba(0, 0, 0, 0.5);
                    border-radius: 0.533vw;
                }
                .label {
                    padding: 2px 6px;
                    font-size: 3.2vw;
                    left: 1.6vw;
                    top: 1.6vw;
                    &.isSpecial{
                        background: #385C40;
                    }
                }
            }
            .text {
                //    margin-left: 36.667vw;
               margin-left: 4vw;
               height: 24.4vw;

               .title {
                   font-size: 4.533vw;
                   line-height: 6.4vw;
                   height: 19.2vw;
                   overflow: hidden;
                   color: #333333;
               }
               .meta {
                   color: #999999;
                   font-size: 3.2vw;
                //    line-height: 3.2vw;
                   margin-top: 1.067vw;
                   display: flex;
                   justify-content: space-between;
                   align-items: center;
               }
               .readNum {
                    float: right;
                    margin-left: 0;
                    img {
                        width: 0.6125rem;
                        height: 0.5rem;
                    }
                }

            //    .line-width {
            //        max-width: 35%;
            //    }
            }
        }
    }
}
</style>